import client from './client';
import { DashboardResp, MapDashboardResp, MapEquipListResp, PlantImageResp } from './response';

export const getDashboard = (): Promise<DashboardResp> =>
  client.get('v1/dashboard');

export const getMapDashboard = (): Promise<MapDashboardResp> => client.get('v1/dashboard/map');
export const getMapEquipList = (sectionId: number): Promise<MapEquipListResp> => client.get(`v1/dashboard/map/${sectionId}`);

export const getPlantImage = (): Promise<PlantImageResp> => client.get('file/factory/image');
